<template>
  <q-spinner
    v-if="show"
    size="lg"
    color="accent"
  />
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'UiLoadingIndicator',

  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    ...mapState('application', ['canInteract']),
  },
};
</script>
